import { combineReducers } from "redux";

import { applicationReducer } from "./applicationReducer";
import { authReducer } from "./authReducer";
import { billingLocationsReducer } from "./billingLocationsReducer";
import { billingReducer } from "./billingReducer";
import { billingsReducer } from "./billingsReducer";
import { collectionPointReducer } from "./collectionPointReducer";
import { collectionPointsReducer } from "./collectionPointsReducer";
import { collectionYardDetailSettingsReducer } from "./collectionYardDetailSettingsReducer";
import { collectionYardsReducer } from "./collectionYardsReducer";
import { collectionYardsSettingsReducer } from "./collectionYardsSettingsReducer";
import { collectionYardsVisitsDetailReducer } from "./collectionYardsVisitsDetailReducer";
import { collectionYardVisitEventsReducer } from "./collectionYardVisitEventsReducer";
import { inventorySheetReducer } from "./inventorySheetReducer";
import { locationReducer } from "./locationReducer";
import { mayorModulesReducer } from "./mayorModulesReducer";
import { monthlyWasteWeightReducer } from "./monthlyWasteWeightReducer";
import { notificationReducer } from "./notificationReducer";
import { settingsReducer } from "./settingsReducer";
import { wagonEventCreateReducer } from "./wagonEventCreateReducer";
import { wagonEventDetailReducer } from "./wagonEventDetailReducer";
import { wagonsCalendarReducer } from "./wagonsCalendarReducer";
import { wagonsDatePickerReducer } from "./wagonsDatePickerReducer";
import { wagonsReportReducer } from "./wagonsReportStateReducer";
import { wasteTypesQuantityReducer } from "./wasteTypesQuantityReducer";
import { weightHistoryReducer } from "./weightHistoryReducer";

export const rootReducer = combineReducers({
  auth: authReducer,
  application: applicationReducer,
  settings: settingsReducer,
  collectionPoints: collectionPointsReducer,
  collectionPoint: collectionPointReducer,
  collectionYards: collectionYardsReducer,
  collectionYardsVisitsDetail: collectionYardsVisitsDetailReducer,
  collectionYardDetailSettings: collectionYardDetailSettingsReducer,
  collectionYardsSettings: collectionYardsSettingsReducer,
  collectionYardVisitEvents: collectionYardVisitEventsReducer,
  notification: notificationReducer,
  weightHistory: weightHistoryReducer,
  wasteTypesQuantity: wasteTypesQuantityReducer,
  location: locationReducer,
  wagonsCalendar: wagonsCalendarReducer,
  monthlyWasteWeight: monthlyWasteWeightReducer,
  wagonEventCreate: wagonEventCreateReducer,
  wagonEventDetail: wagonEventDetailReducer,
  mayorModules: mayorModulesReducer,
  wagonsDatePicker: wagonsDatePickerReducer,
  wagonsReport: wagonsReportReducer,
  inventorySheet: inventorySheetReducer,
  billings: billingsReducer,
  billing: billingReducer,
  billingLocations: billingLocationsReducer,
});
